import { Button } from '@mui/material';
import React, { FC } from 'react';
import { ToolTip } from '../Tooltip/ToolTip';
import { isIconiqa } from '../../utils/validators/HelperFunctions';
import './styles.css';

type PrimaryButtonProps = {
  onClick?: (e?: any) => void;
  disabled?: boolean;
  children: React.ReactNode | string;
  variant?: any;
  className?: string;
  fullWidth?: boolean;
  title?: string;
  sx?: any;
  type?: any;
  tooltipInfo?: string;
  spanStyle?: Object;
};

const PrimaryButton: FC<PrimaryButtonProps> = ({
  onClick,
  disabled,
  variant = 'contained',
  fullWidth = true,
  className,
  children,
  title,
  spanStyle,
  type,
  sx,
  tooltipInfo,
  ...rest
}) => {
  const isIconiqaEnv = isIconiqa();

  return (
    <ToolTip title={tooltipInfo}>
      <span style={spanStyle}>
        <Button
          type={type}
          title={title}
          fullWidth={isIconiqaEnv ? false : fullWidth}
          data-testid="primary-button"
          sx={{
            ...sx,
            width: isIconiqaEnv ? 'auto' : undefined,
            minHeight: isIconiqaEnv ? 'auto' : '35px',
            '&:hover': {
              boxShadow: isIconiqaEnv ? 'none' : '0 8px 8px rgba(0, 0, 0, 0.1)',
            },
            '&.MuiButtonBase-root': {
              borderRadius: isIconiqaEnv ? '8px' : '0%',
              fontSize: '0.75rem',
              fontWeight: 500,
            },
            textTransform: isIconiqaEnv ? 'uppercase' : 'capitalize',
          }}
          // className={`${variant === "contained" ? "defaultButton" : "textButton"
          //   } ${className}`}
          disabled={disabled}
          onClick={onClick}
          variant={variant}
          {...rest}>
          {children}
        </Button>
      </span>
    </ToolTip>
  );
};
export default PrimaryButton;
